import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["handleChange"];
var __jsx = React.createElement;
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import isNil from 'lodash/isNil';
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useFieldError } from 'libs/content/hooks';
import { StyledCalendar } from './DateInput.style';

var DateInput = function DateInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      defaultValue = _ref.defaultValue,
      _ref$withTime = _ref.withTime,
      withTime = _ref$withTime === void 0 ? false : _ref$withTime,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var errorMessage = useFieldError(name);

  var handleChange = options.handleChange,
      otherOptions = _objectWithoutProperties(options, _excluded);

  var dateFormat = withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';

  var _useState = useState(),
      date = _useState[0],
      setDate = _useState[1];

  var _useState2 = useState(undefined),
      selectorOpened = _useState2[0],
      setSelectorOpened = _useState2[1];

  var handleOpen = function handleOpen() {
    return setSelectorOpened(true);
  };

  var handleClose = function handleClose() {
    if (selectorOpened === true) {
      setSelectorOpened(false);

      if (handleChange !== undefined) {
        handleChange(date);
      }
    }
  };

  return __jsx(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, __jsx(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '',
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          _onChange = _ref2$field.onChange,
          value = _ref2$field.value;
      return withTime ? __jsx(KeyboardDateTimePicker, _extends({
        id: "form-field-".concat(name),
        onChange: function onChange() {
          for (var _len = arguments.length, event = new Array(_len), _key = 0; _key < _len; _key++) {
            event[_key] = arguments[_key];
          }

          var _date = event[0];

          if (_date !== null && _date !== undefined && !isNaN(_date.getTime())) {
            setDate(_date);

            if (selectorOpened !== true && handleChange !== undefined) {
              handleChange(_date);
            }
          } else {
            setDate(undefined);

            if (selectorOpened !== true && handleChange !== undefined) {
              handleChange(undefined);
            }
          }

          _onChange(_date);
        },
        value: value,
        name: name,
        label: label,
        inputVariant: "outlined",
        variant: "inline",
        format: dateFormat,
        keyboardIcon: __jsx(StyledCalendar, null),
        error: Boolean(errorMessage),
        helperText: errorMessage,
        InputLabelProps: {
          shrink: !isNil(value)
        },
        onOpen: handleOpen,
        onClose: handleClose
      }, otherOptions)) : __jsx(KeyboardDatePicker, _extends({
        id: "form-field-".concat(name),
        onChange: _onChange,
        value: value,
        name: name,
        label: label,
        inputVariant: "outlined",
        variant: "inline",
        format: dateFormat,
        keyboardIcon: __jsx(StyledCalendar, null),
        error: Boolean(errorMessage),
        helperText: errorMessage,
        InputLabelProps: {
          shrink: !isNil(value)
        }
      }, otherOptions));
    }
  }));
};

export default DateInput;